import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Select, MenuItem, InputLabel, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import { LoadingButton } from '@mui/lab';
import AutocompleteTopicz from '../components/AutocompleteTopicz';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import QuestionBankUpload from './QuestionBankUpload';
import QuestionView from './QuestionView';
import QuestionViewCD from './QuestionViewCD';
import QuestionEdit from './QuestionEdit';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin');
	const childRefNewSave = React.useRef();
	const childRefUpload = React.useRef();
	const childRefAuthorization = React.useRef();
	const childRefQW = React.useRef();
	const childRefCD = React.useRef();
	const childRefEdit = React.useRef();	
	///const authResult = new URLSearchParams(window.location.search);

	const [pageLoading, setPageLoading] = React.useState(true);
	const [deleteDialogOpt, setDeleteDialogOpt] = React.useState(0);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [batches, setBatches] = React.useState([]);
	const [difficultyList, setDifficultyList] = React.useState([]);
	const [gradeList, setGradeList] = React.useState([]);
	const [examTypeList, setExamTypeList] = React.useState([]);
	const [questionTypeList, setQuestionTypeList] = React.useState([]);
	const [dataLoading, setDataLoading] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(74);
	const pageSize = 10;

	const [topicList, setTopicList] = React.useState([]);
	const [topicId, setTopicId] = React.useState(0);
	const [topicName, setTopicName] = React.useState("");
	const [batchId, setBatchId] = React.useState(0);
	const [difficultyId, setDifficultyId] = React.useState(0);
	const [gradeId, setGradeId] = React.useState(0);
	const [examType, setExamType] = React.useState('NotSelected');
	const [questionTypeId, setQuestionTypeId] = React.useState(0);
	const [isDeleting, setIsDeleting] = React.useState(false);
	const [isDeletingAll, setIsDeletingAll] = React.useState(false);
	const [syncCounter, setSyncCounter] = React.useState(false);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [privileges, setPrivileges] = React.useState("");

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'srno', headerName: 'Sr. No.', width: 40 },
		{ field: 'displayId', headerName: 'Display ID', width: 110},
		{ field: 'autoId', headerName: 'Question ID', width: 100},
		{ field: 'batchId', headerName: 'Batch ID', width: 110},
		{ field: 'questionType', headerName: 'Question Type', width: 210, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'topicName', headerName: 'Topic', width: 300, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	    { field: 'keywordNames', headerName: 'Keywords', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'gradeName', headerName: 'Grade', width: 70},
		{ field: 'difficultyName', headerName: 'Difficulty', width: 70},		
		{ field: 'tags', headerName: 'Tags', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'examType', headerName: 'Exam Type', width: 100},
		{ field: 'language', headerName: 'Language', width: 100},
		{ field: 'bloomName', headerName: 'Bloom', width: 100},
		{ field: 'country', headerName: 'Country', width: 100},
	    { field: 'modifiedBy', headerName: 'Modified By', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'modifiedDateTime', headerName: 'Modified Date/Time', width: 165},
		
		    
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	const handlePageChange = (newPage) => {	
		setSelectedRow(0);
		setDataObj(null);
		setPage(newPage);
		setFilter(!filter);
	  };

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){
			getApiData();
		}
	}, [userObj]);

	async function getApiData(){
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			let endpoints1 = env.API_URL+"/topic-service/read/list?sortby=topicName";
			const axiosrequest1 = axios.get(endpoints1,axiosHeader);
			await axios.all([axiosrequest1]).then(axios.spread(function(res1) {
			  setPageLoading(false);
			  setTopicList(res1.data.obj.list);
			}));
	}

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){
			setSelectedRow(0);
			setDataObj({});
			getApiQuestions();
		}
	}, [filter]);

	async function getApiQuestions(){
		///alert(userObj.token);
		if((topicId && topicId>0) || (keyword && keyword.length>0)){
			setPageLoading(true);
			setDataLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 

			let qstr="&topicId="+topicId;
			if(batchId && batchId>0){
				qstr+="&batchId="+batchId;
			}
			if(difficultyId && difficultyId>0){
				qstr+="&difficultyId="+difficultyId;
			}
			if(gradeId && gradeId>0){
				qstr+="&gradeId="+gradeId;
			}
			if(examType && examType.length>0 && examType!=='NotSelected'){
				qstr+="&examType="+examType;
			}
			if(questionTypeId && questionTypeId>0){
				qstr+="&questionTypeId="+questionTypeId;
			}
			if(keyword && keyword.length>0){
				qstr+="&keyword="+keyword;
			}
			axios.get(env.API_URL+"/exams/read/mgnt-question-banks?minRows="+(page*pageSize)+"&maxRows="+pageSize+qstr, axiosHeader) 
			   .then(response => {
				//document.write(JSON.stringify(response));
				 setPageLoading(false); 
				 setDataLoading(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					if(page===0){
						setRowCount(response.data.obj.rowCount);
					}
					setRows(response.data.obj.list);
					setPrivileges(response.data.obj.privileges);
					setBatches(response?.data?.obj?.batches);
					setDifficultyList(response?.data?.obj?.difficultyList);
					setGradeList(response?.data?.obj?.gradeList);
					setExamTypeList(response?.data?.obj?.examTypeList);
					setQuestionTypeList(response?.data?.obj?.questionTypeList);
					
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
		}	
	}


	function deleteData(){
		if(dataObj!=null && userObj.loginId && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

			if(deleteDialogOpt===2){
				setIsDeletingAll(true);
			}else{
				setIsDeleting(true);
			}			  
		  
		  setDeleteDialogShow(false);

		  const data = new FormData();
			data.append('flag', deleteDialogOpt); // flag 2 means multiple deletion and flag 1 means single deletion
			data.append('id', dataObj?.autoId?dataObj.autoId:0);
			data.append('topicId', topicId);
			if(batchId && batchId>0){
				data.append('batchId', batchId);
			}
			if(difficultyId && difficultyId>0){
				data.append('difficultyId', difficultyId);
			}
			if(gradeId && gradeId>0){
				data.append('gradeId', gradeId);
			}
			if(examType && examType.length>0 && examType!=='NotSelected'){
				data.append('examType', examType);
			}
			if(questionTypeId && questionTypeId>0){
				data.append('questionTypeId', questionTypeId);
			}
			if(keyword && keyword.length>0){
				data.append('keyword', keyword);
			}
		   
		  axios.post(env.API_URL+'/exams/delete/question-bank', data, axiosHeader)
				.then((response) => {
					setIsDeleting(false);		
					setIsDeletingAll(false);
					setDeleteDialogOpt(0);			
					setBatchId(0);
					setDifficultyId(0);
					setGradeId(0);
					setExamType('NotSelected');
					setQuestionTypeId(0);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Question has been deleted");
					search();
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Question could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	
		
	}

	function updateQuestionCounter(){
		if(userObj.loginId && userObj.token && topicId && topicId>0){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('topicId', topicId);

		  setSyncCounter(true);	
		  axios.post(env.API_URL+'/exams/read/topicwise-question-counter', data, axiosHeader)
				.then((response) => {
					setSyncCounter(false);		
					setDeleteDialogOpt(0);			
					setBatchId(0);
					setDifficultyId(0);
					setGradeId(0);
					setExamType('NotSelected');
					setQuestionTypeId(0);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Counter synchronization has been initiated. it will take aprox 10 minutes to update count chart");
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Counter could not be initiated.");			
					return false;
				}
			}).catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	
		
	}


	function saveData(opt){
		if(opt===1){
			setDataObj({});
			childRefNewSave.current.handleClickOpen();
		}else if(opt===2){
			childRefEdit.current.handleClickOpen();		
		}else if(opt===3){
			childRefUpload.current.handleClickOpen();
		}	
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setPage(0);
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}
		
	function updatedList(){
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	}


	function selectTopic(obj) {
		if(obj && obj.autoId>0){
		  setKeyword('');
		  setTopicId(obj.autoId);
		  setTopicName(obj.topicName);
		  search();
		}else{
			setKeyword('');
		  	setTopicId(0);
		  	setTopicName('');
		}   
	}

	// function numberOnly(event){
	// 	if(event.key === 'Enter'){
	// 		search();
	// 	}else if (!/[0-9]/.test(event.key)) {
	// 		event.preventDefault();
	// 	} 
	// }

	function deleteQue(opt){
		setDeleteDialogOpt(opt);
		setDeleteDialogShow(true);
	}

	function htmlView(){
		if(dataObj?.questionType?.indexOf("Common Data")>-1){
			childRefCD.current.handleClickOpen();
		}else{
			childRefQW.current.handleClickOpen();
		}
	}

	function reloadFlag(flag){
		if(flag===true){
			setSelectedRow(0);
			setDataObj({});
			getApiQuestions();
		}
	  }
	

	return (
		<div> 
				<MetaTags>
            		<title>Question Banks</title>
          		</MetaTags>
				
				<Header title='Questions Management' />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<div style={{marginRight:5, width: 250, float:'left' }}>
										{(topicList && topicList.length>0)?
											<AutocompleteTopicz options={topicList} defaultValue={topicName} handleSelect={selectTopic} variant="outlined" />
										:<>No Topic Found</>}
										{/* <AutocompleteTopics selectTopic={selectTopic} topicsList={topicList} topicName={topicName} variant="outlined" label="Topic" /> */}
									</div>
									
									{(topicId && topicId>0)?<>
									
									{(batches && batches.length>0)?
									<FormControl fullWidth style={{float:'left',width:125,marginRight:4}} >
									<InputLabel id="type-select-label">Batch</InputLabel>
									<Select 
										label="Batch"
										style={{width:'99%'}}
										labelId="type-select-label"
										id="select-class"
										size="small"
										value={batchId}									
										onChange={event => setBatchId(event.target.value)}
									>
											<MenuItem value={0} >Not Selected</MenuItem>
											{batches?batches.map((val,i)=>(
												<MenuItem key={'bt'+i} value={val} >{val}</MenuItem>
											)):null}
									</Select>
									</FormControl>
									:null}
									
									{(difficultyList && difficultyList.length>0)?
									<FormControl fullWidth style={{float:'left',width:125,marginRight:4}} >
									<InputLabel id="type-select-label">Difficulty</InputLabel>
									<Select 
										label="Difficulty"
										style={{width:'99%'}}
										labelId="type-select-label"
										id="select-class"
										size="small"
										value={difficultyId}									
										onChange={event => setDifficultyId(event.target.value)}
									>
											<MenuItem value={0} >Not Selected</MenuItem>
											{difficultyList?difficultyList.map((row,i)=>(
												<MenuItem key={'diff'+i} value={row.autoId} >{row.difficultyName}</MenuItem>
											)):null}
									</Select>
									</FormControl>
									:null}

									{(gradeList && gradeList.length>0)?
									<FormControl fullWidth style={{float:'left',width:125,marginRight:4}} >
									<InputLabel id="type-select-label">Grade</InputLabel>
									<Select 
										label="Grade"
										style={{width:'99%'}}
										labelId="type-select-label"
										id="select-class"
										size="small"
										value={gradeId}									
										onChange={event => setGradeId(event.target.value)}
									>
											<MenuItem value={0} >Not Selected</MenuItem>
											{gradeList?gradeList.map((row,i)=>(
												<MenuItem key={'diff'+i} value={row.autoId} >{row.gradeName}</MenuItem>
											)):null}
									</Select>
									</FormControl>
									:null}

									{(examTypeList && examTypeList.length>0)?
									<FormControl fullWidth style={{float:'left',width:120,marginRight:4}} >
									<InputLabel id="type-select-label">Exam Type</InputLabel>
									<Select 
										label="Exam Type"
										style={{width:'99%'}}
										labelId="type-select-label"
										id="select-class"
										size="small"
										value={examType}									
										onChange={event => setExamType(event.target.value)}
									>
											<MenuItem value={'NotSelected'} >Not Selected</MenuItem>
											{examTypeList?examTypeList.map((val,i)=>(
												<MenuItem key={'et'+i} value={val} >{val}</MenuItem>
											)):null}
									</Select>
									</FormControl>
									:null}

									{(questionTypeList && questionTypeList.length>0)?
									<FormControl fullWidth style={{float:'left',width:140,marginRight:4}} >
									<InputLabel id="type-select-label">Question Type</InputLabel>
									<Select 
										label="Question Type"
										style={{width:'99%'}}
										labelId="type-select-label"
										id="select-class"
										size="small"
										value={questionTypeId}									
										onChange={event => setQuestionTypeId(event.target.value)}
									>
											<MenuItem value={0} >Not Selected</MenuItem>
											{questionTypeList?questionTypeList.map((row,i)=>(
												<MenuItem key={'qt'+i} value={row.autoId} >{row.questionTypeName}</MenuItem>
											)):null}
									</Select>
									</FormControl>
									:null}


									</>:null}	

									<FormControl style={{float:'left',width:140,marginRight:7}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 140 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{float:'left', marginTop: 1,paddingLeft:0,paddingRight:0}} size="small" variant="contained" >GO</Button>

									
									<div style={{float:'left', marginTop: 5}}>
									
										{/* {(privileges && privileges.length>0 && privileges.indexOf("create")>-1)? */}
										{/* :null}	 */}
										{/* {(privileges && privileges.length>0 && privileges.indexOf("create")>-1)?
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
										:null} */}
										{selectedRow>0?<>
											{!isDeleting?<>
												<i onClick={()=>{saveData(3)}} title="Edit Question By Upload Object Bank" className="fa fa-cloud-upload" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
												<i onClick={()=>{htmlView()}} title="HTML View" className="fa fa-info-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
												{(privileges && privileges.length>0 && privileges.indexOf("update")>-1)?
													<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
												:null}
											</>:null}
											{(privileges && privileges.length>0 && privileges.indexOf("delete")>-1)?<>
													{isDeleting?
														<LoadingButton loadingPosition='start' startIcon={<div style={{marginRight:18}}></div>} loading={isDeleting} style={{backgroundColor:'#ff6e00',color:'#FFF',marginLeft:10}} size="small" variant="contained"  >Deleting...</LoadingButton>
													:<>
														<i onClick={()=>{deleteQue(1)}} title="Delete Selected" className="fa fa-trash" style={{fontSize:30, color:'#ff0000',marginLeft:15, cursor:'pointer'}} />
													</>
													}
											</>:null}
										</>:null}

										{(!selectedRow && rows && rows.length>0)?<div style={{marginTop:-4}}>
											{(privileges && privileges.length>0 && privileges.indexOf("delete")>-1)?<>
													{isDeletingAll?
													<LoadingButton loadingPosition='start' startIcon={<div style={{marginRight:18}}></div>} loading={isDeletingAll} style={{backgroundColor:'#ff6e00',color:'#FFF',marginLeft:10}} size="small" variant="contained"  >Deleting</LoadingButton>
													:<>
													<Button onClick={() => {deleteQue(2)}} style={{marginLeft:10, backgroundColor:'#ff0000', color:'#fff'}} size="small" variant="contained" >Delete All</Button>
													</>
													}
											</>:null}	
											{syncCounter?
											<LoadingButton loadingPosition='start' startIcon={<div style={{marginRight:18}}></div>} loading={true} style={{marginLeft:10}} size="small" color="primary" variant="outlined"  >Synchronizing...</LoadingButton>
											:<><Button onClick={() => {updateQuestionCounter()}} style={{marginLeft:10}} size="small" color="primary" variant="outlined" >Sync Count</Button></>
  											}
										</div>:null}

									</div>

								</Grid>
							</Grid>
					</Box>

					{((topicId && topicId>0) || (keyword && keyword.length>0))?						
					<div className="tblReport" style={{height: '76vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}								
							paginationMode="server"
							onPageChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}	
							///onCellClick={handleOnCellClick}		
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>
					</div>
					:null}

				</Box>
				
			<QuestionBankUpload dataObj={dataObj} topicId={topicId} topicName={topicName} ref={childRefUpload} updatedList={updatedList} />
			<QuestionView dataObj={dataObj} ref={childRefQW} />
			<QuestionViewCD dataObj={dataObj} privileges={privileges} updateBtn={true} ref={childRefCD} />			
			<QuestionEdit dataObj={dataObj} reloadFlag={reloadFlag} ref={childRefEdit} />

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }